import { Component, inject, input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '../button/button.component';
import { FormDropdownComponent } from '../form/form-dropdown/form-dropdown.component';
import { FormMoneyComponent } from '../form/form-money/form-money.component';
import { LookupStore, WizardClassViewModel, WizardStore } from '@program-suite/data-common';
import { IconComponent } from '@program-suite/util-icons';
import { CurrencyPipe } from '@angular/common';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// Step 2's owners, employees, payroll, and classification questions. Shared by step 2 and the
// missing info modal, which bind the same step 2 form. The percentage auto-split and class payroll
// math stay in WizardStep2Component, which is always rendered in the stepper.
@Component({
  selector: 'lib-payroll-classes',
  imports: [FormDropdownComponent, FormMoneyComponent, ReactiveFormsModule, IconComponent, ButtonComponent, CurrencyPipe, MatError, MatFormFieldModule, MatInputModule],
  templateUrl: './payroll-classes.component.html',
  styleUrl: './payroll-classes.component.scss',
})
export class PayrollClassesComponent {
  form = input.required<FormGroup>();
  // The modal only asks for percentage of work, so it hides the total payroll and its errors
  showTotalPayroll = input(true);
  wizardStore = inject(WizardStore);
  lookupStore = inject(LookupStore);
  private _fb = inject(FormBuilder);

  // 1-10 owners active in the field
  fieldOwnerOptions = Array.from({ length: 10 }, (_, i) => ({ id: `${i + 1}`, name: `${i + 1}`, value: i + 1 }));

  // 0-20 employees; 0 means owner-only
  employeeOptions = Array.from({ length: 21 }, (_, i) => ({ id: `${i}`, name: `${i}`, value: i }));

  get classesFormArray(): FormArray {
    return this.form().get('classes') as FormArray;
  }

  addClass(classData: WizardClassViewModel = { classCode: '', payroll: undefined }): void {
    const classGroup = this._fb.group({
      classCode: [classData.classCode || '', Validators.required],
      // payroll is no longer entered; it will be calculated from percentageOfWork
      payroll: [classData.payroll || null],
      percentageOfWork: [classData.percentageOfWork ?? null, [Validators.required, Validators.min(1), Validators.max(100)]],
    });
    this.classesFormArray.push(classGroup);
  }

  // Remove a class from the FormArray. Step 2 has already noticed any edited percentage,
  // since typing in it fires the classes valueChanges it watches.
  removeClass(index: number): void {
    if (index > 0) { // don't remove the first class
      this.classesFormArray.removeAt(index);
    }
  }
}
